import React, { useEffect } from "react"
import { withRouter } from "react-router-dom"
import { connect } from "react-redux"
import _ from "../../utils/lodashUtils"
import InvitePeoplePage from "../../containers/InvitePeoplePage/InvitePeoplePage"
import CouplingPage from "../../containers/CouplingPage/CouplingPage"
import { fetchPartnerDetails } from "../../redux/actionCreators/invitePeople"
import {
  FirebaseService,
  FirebaseContext,
  FIREBASE_STATE_KEYS,
} from "../../firebase"
import { SCREENS } from "../../constants/screens"
import AcceptOrRejectInvite from "../../components/AcceptOrRejectInvite/AcceptOrRejectInvite"
import { ActivityIndicator } from "../../components/ActivityIndicator"

const Dashboard = (props) => {
  const { userState, partnerState, dateState } = React.useContext(
    FirebaseContext
  )
  const datingStatus = _.get(dateState, FIREBASE_STATE_KEYS.STATUS, "INACTIVE")
  const partnerAcceptNotify = _.get(
    userState,
    FIREBASE_STATE_KEYS.NOTIFY_INVITE
  )
  const isOrderCombined = _.get(dateState, "isOrderCombined", null)
  const activeRoute = _.get(userState, FIREBASE_STATE_KEYS.ACTIVE_ROUTE)
  // Handle Contact Scenarios
  const userDisplayName = _.get(props, "user.display_name", null)
  const firebaseDefaultPath = FirebaseService.getDefaultPath()

  useEffect(() => {
    props.fetchPartnerDetails()
  }, [datingStatus])

  if (userDisplayName === null) {
    const location = {
      pathname: "/contact",
      state: {
        fromLogin: _.get(props.history.location, "state.fromLogin", false),
      },
    }
    props.history.push(location)
    return <div></div>
  }

  // IMP: Starting screen for sync state in Firebase.
  if (
    firebaseDefaultPath !== undefined &&
    (!FirebaseService.AUTH.currentUser || !userState || !partnerState) &&
    datingStatus !== "INACTIVE"
  ) {
    return <ActivityIndicator global />
  }
  if (isOrderCombined !== null && !userState) {
    FirebaseService.patch(
      {
        [FIREBASE_STATE_KEYS.USER_DETAILS]: props.user,
        [FIREBASE_STATE_KEYS.ACTIVE_SCREEN]: SCREENS.COUPLING,
      },
      `${firebaseDefaultPath}${props.user.uuid}`
    )
    return <CouplingPage />
  } else {
    if (activeRoute && activeRoute !== "/dashboard") {
      props.history.push(activeRoute)
      return <div></div>
    }
    // Handle Invite Scenarios
    if (
      props.invite.isInvited === null &&
      _.isEmpty(props.invite.partnerDetails)
    ) {
      return <InvitePeoplePage />
    } else if (props.invite.isInvited !== null && !props.invite.confirmed) {
      return <InvitePeoplePage />
    } else if (datingStatus == "REJECTED") {
      return <InvitePeoplePage />
    } else if (
      props.invite.partnerDetails &&
      datingStatus == "INACTIVE" &&
      (props.invite.partnerDetails.partner2_identifier ===
        props.user.username ||
        props.invite.partnerDetails.partner2_identifier === props.user.email ||
        props.invite.partnerDetails.partner2_identifier ===
          props.user.phone_number)
    ) {
      // IMP: Starting screen for sync state in Firebase.
      FirebaseService.patch(
        {
          [FIREBASE_STATE_KEYS.USER_DETAILS]: props.user,
          [FIREBASE_STATE_KEYS.ACTIVE_SCREEN]: SCREENS.SECRET_VERIFICATION,
        },
        `${firebaseDefaultPath}${props.user.uuid}`
      )
      return <AcceptOrRejectInvite />
    } else if (datingStatus == "INACTIVE") {
      FirebaseService.patch(
        {
          [FIREBASE_STATE_KEYS.USER_DETAILS]: props.user,
          [FIREBASE_STATE_KEYS.ACTIVE_SCREEN]: SCREENS.COUPLING,
        },
        `${firebaseDefaultPath}${props.user.uuid}`
      )
      return <CouplingPage />
    } else if (datingStatus == "ACTIVE" && !partnerAcceptNotify) {
      FirebaseService.patch(
        {
          [FIREBASE_STATE_KEYS.USER_DETAILS]: props.user,
          [FIREBASE_STATE_KEYS.ACTIVE_SCREEN]: SCREENS.PLAN_NEW_DATE,
        },
        `${firebaseDefaultPath}${props.user.uuid}`
      )
      FirebaseService.setActiveRoute("/plan-new-date")
      return <div></div>
    } else {
      // Handle Invite Scenarios
      if (
        props.invite.isInvited === null &&
        _.isEmpty(props.invite.partnerDetails)
      ) {
        return <InvitePeoplePage />
      } else if (props.invite.isInvited !== null && !props.invite.confirmed) {
        return <InvitePeoplePage />
      } else if (datingStatus == "REJECTED") {
        return <InvitePeoplePage />
      } else if (
        props.invite.partnerDetails &&
        datingStatus == "INACTIVE" &&
        (props.invite.partnerDetails.partner2_identifier ===
          props.user.username ||
          props.invite.partnerDetails.partner2_identifier ===
            props.user.email ||
          props.invite.partnerDetails.partner2_identifier ===
            props.user.phone_number)
      ) {
        // IMP: Starting screen for sync state in Firebase.
        FirebaseService.patch(
          {
            [FIREBASE_STATE_KEYS.USER_DETAILS]: props.user,
            [FIREBASE_STATE_KEYS.ACTIVE_SCREEN]: SCREENS.SECRET_VERIFICATION,
          },
          `${firebaseDefaultPath}${props.user.uuid}`
        )
        return <AcceptOrRejectInvite />
      }
    }
    FirebaseService.patch(
      {
        [FIREBASE_STATE_KEYS.USER_DETAILS]: props.user,
        [FIREBASE_STATE_KEYS.ACTIVE_SCREEN]: SCREENS.PLAN_NEW_DATE,
      },
      `${firebaseDefaultPath}${props.user.uuid}`
    )
    return <CouplingPage />
  }
}

const mapStateToProps = (state) => ({
  user: state.auth.user,
  invite: state.invitePeople,
  partner: state.partner,
  partners: state.invitePeople.partnerDetails,
  partnerDetails: state.auth.partner,
})

export default withRouter(
  connect(mapStateToProps, {
    fetchPartnerDetails,
  })(Dashboard)
)
